












import Vue, { PropType } from 'vue';
import VuePagination from 'vue-pagination-2';
import { Pagination } from '@/api/interfaces/common/pagination';

export default Vue.extend({
    name: 'AppPagination',
    components: {
        VuePagination,
    },
    props: {
        page: {
            type: Number,
            default: 1,
        },
        pagination: {
            type: Object as PropType<Pagination>,
            required: true,
        },
        texts: {
            type: Object as PropType<unknown>,
            default: {
                first: '<<<',
                last: '>>>',
                count:
                    'Zeige {from} bis {to} von {count} Anträgen|{count} Anträge|Ein Antrag',
            },
        },
    },
    data() {
        return {
            internalPage: this.page,
            temporaryDisablePageChangedEvent: false,
        };
    },
    computed: {
        paginationOptions(): unknown {
            return {
                chunk: 10,
                edgeNavigation: true,
                texts: this.texts,
            };
        },
    },
    watch: {
        'pagination.offset'(): void {
            this.temporaryDisablePageChangedEvent = true;
            const page =
                1 + Math.floor(this.pagination.offset / this.pagination.limit);
            this.internalPage = isNaN(page) ? 1 : page;
            this.$nextTick(() => {
                this.temporaryDisablePageChangedEvent = false;
            });
        },
    },
    methods: {
        paginationCallback(page: number) {
            if (!this.temporaryDisablePageChangedEvent) {
                // Page is 1-based, not 0-based.
                this.$emit('pagination-page-changed', page);
            }
        },
    },
});
